import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from '@material-ui/icons/Clear';

import { ReactComponent as SearchIcon } from "./assets/search.svg";

const useStyles = makeStyles({
  root: {
    width: "100%",
    //borderBottom: "1px solid #2545BD",
    position: "relative",
    borderRadius: "14px 14px 0 0",
  },
  header: {
    borderRadius: "7px 7px 0 0",
    background: "linear-gradient(270deg, #070D29 0%, #14259B 100%)",
    color: "#E9ECFF",
    fontSize: "12px",
    fontWeight: 600,
    padding: "6px 13px",
  },
  input: {
    background: "#fff",
    //background: "#ECF5FF",
    color: "#3A4671",
    width: "100%",
    border: "0",
    height: "45px",
    fontSize: "14px",
    //fontSize: "12px",
    //height: "40px",
    padding: "0 40px 0 10px",
    boxShadow: "inset 0 -7px 9px -7px rgba(37, 69, 189,0.4)",
    borderRadius: "14px 14px 0 0",
    outline: 0,
  },
  icon: {
    position: "absolute",
    bottom: "12px",
    //bottom: "10px",
    right: "10px",
    color: "#2545BD",
    cursor: "pointer",
    "&>.searchIcon path": {
      fill: "#2545BD",
    },
    "&>.clearIcon": {
      position: "relative",
      top: "3px",
    }
  },
  noBrd: {
    borderRadius: "0",
  },
  bTop: {
    borderTop: "1px solid rgba(37, 69, 189,0.4)"
  },
});

const SearchTemplate = props => {
  const classes = useStyles();

  const {
    search,
    onChange,
    onSearch,
    noRadius,
    //title,
    placeholder
  } = props;

  const [state, setState] = React.useState({
    icon: 0,
    value: "",
  });

  React.useEffect(() => {
    if (!search) {
      setState({
        icon: 0,
        value: ""
      });
    }
  }, [search]);

  const handleSearchValueChange = event => {
    onChange(event.target.value);
    if (event.target.value !== state.value) {
      setState({
        icon: 0,
        value: ""
      });
    }
  };
  const handleSubmitSearchValue = () => {
    setState({
      icon: 1,
      value: search
    });
    onSearch();
  };
  const handleClearSearchValue = () => {
    setState({
      icon: 0,
      value: ""
    });
    onChange("", "clear");
  };

  const handleKeyDown = (event) => {
    if (event && event.key === 'Enter') {
      handleSubmitSearchValue();
    }
  }

  let iconContent = null;
  if (state.icon === 1) {
    iconContent = <div className={classes.icon} onClick={handleClearSearchValue}>
      <ClearIcon className={"clearIcon"} />
    </div>;
  } else {
    iconContent = <div className={classes.icon} onClick={handleSubmitSearchValue}>
      <SearchIcon className={"searchIcon"} />
    </div>;
  }

  return (
    <div className={`${classes.root} ${noRadius ? `${classes.noBrd} ${classes.bTop}` : ''}`}>
      {/*<div className={classes.header}>{title}</div>*/}
      <input
        onChange={handleSearchValueChange}
        onKeyDown={handleKeyDown}
        value={search}
        type="text"
        placeholder={placeholder}
        className={`${classes.input} ${noRadius ? classes.noBrd : ''}`}
      />
      {iconContent}
    </div>
  )
};

SearchTemplate.propTypes = {
  search: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
};

SearchTemplate.defaultProps = {
  search: "",
  title: "TITLE",
  placeholder: "PLACEHOLDER",
  onChange: () => { },
  onSearch: () => { },
};

export default React.memo(SearchTemplate);
